/**
 * The 0 to 10 importance a PXL score set (each of potential, exposure and ease rated 1 to 5)
 * implies, which is what the experiment list sorts on. Shared by the dashboard's Importance card
 * and the MCP write tools (PER-330), so a rating saved either way sorts the same.
 */
type PxlScoreSet = { p: number; x: number; l: number };

export const importanceFromScores = (scores: Readonly<PxlScoreSet>): number =>
  Math.min(10, Math.max(0, Math.round(((scores.p + scores.x + scores.l) / 3) * 2)));
